import { useState, useEffect } from 'react';
import { IconExpand, IconCollapse } from '@ui/src';
// import CommentBlock from './comment-block';
import { useAppSelector } from '@store';
import {
  AmlAction,
  // AmlComment,
} from '../../../hoc/customers/types';
import { ExpandableRowTypes } from './types';

import cn from './aml.module.css';

const ExpandableRow = ({
  title,
  expandedRows,
  setExpandedRows,
  name,
  totalRisk,
  children,
  // comments,
  // onSend,
  // onDelete,
  element,
}: ExpandableRowTypes): React.JSX.Element => {
  const [expanded, setExpanded] = useState(
    Boolean(expandedRows.find((item) => item === name)),
  );

  const { riskScoreRanges } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  const onExpand = () => {
    let nextExpandedRows = ([] as string[]).concat(expandedRows);

    if (expanded) {
      nextExpandedRows = nextExpandedRows.filter((item) => item !== name);
    } else {
      nextExpandedRows.push(name);
    }

    if (setExpandedRows) {
      setExpandedRows(nextExpandedRows);
    }
  };

  useEffect(() => {
    setExpanded(Boolean(expandedRows.find((item) => item === name)));
  }, [expandedRows, name]);

  let totalRiskClassName: string;

  const riskLevel = riskScoreRanges?.find(
    (item) => totalRisk >= item.rangeStart && totalRisk <= item.rangeEnd,
  );

  if (riskLevel?.action === AmlAction.NONE) {
    totalRiskClassName = cn.totalRiskScoringGood;
  } else if (riskLevel?.action === AmlAction.OPS_REVIEW) {
    totalRiskClassName = cn.totalRiskScoringMedium;
  } else {
    totalRiskClassName = cn.totalRiskScoringLow;
  }

  return (
    <div className={cn.expandableRow}>
      <div className={cn.expandableRowTop}>
        <div className={cn.expandableRowTitle}>{title}</div>
        <div className={cn.expandableRowTopRight}>
          <div className={`${cn.expandableRowTotalRisk} ${totalRiskClassName}`}>
            {totalRisk?.toString() || 'Calculating'}
          </div>

          <button
            type="button"
            onClick={onExpand}
            className={cn.expandableRowButton}
          >
            {expanded ? <IconCollapse /> : <IconExpand />}
          </button>
        </div>
      </div>
      {expanded && (
        <div className={cn.expandableRowContentWrapper}>
          {children}
          {/* <CommentBlock
            name={name}
            comments={comments}
            onSend={onSend}
            onDelete={onDelete}
          /> */}
          {element}
        </div>
      )}
    </div>
  );
};

export default ExpandableRow;
